import React from "react";
import smallimg from "../../Assets/Images/aboutussection/smallimg.png";
import ourMission from '../../Assets/Images/ourMission.png';

const OurMission = () => {
  return (
    <div className="bg-white py-8 sm:py-10">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-8 lg:gap-12 border border-[#FF6B35]/30 rounded-xl p-4 lg:p-6">
          
          {/* Left: Text Content */}
          <div className="order-1 lg:order-1 space-y-4 sm:space-y-5">
            {/* Heading */}
            <div className="flex items-center justify-between space-x-3 sm:space-x-4">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold">
                <span className="text-gray-900">Our</span>{" "}
                <span className="text-[#FF6B35]">Mission</span>
              </h2>
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-[#FF6B35] rounded-full flex items-center justify-center">
                <img
                  src={smallimg}
                  alt="Mission Icon"
                  className="w-4 h-4 sm:w-5 sm:h-5 object-contain"
                />
              </div>
            </div>

            {/* Description */}
            <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed text-justify">
              At Covenants, we strive to create exceptional spaces that inspire and endure.
              Committed to innovation, sustainability, and customer satisfaction, we build
              not just properties, but thriving communities. With integrity and excellence
              at our core, we deliver high-quality developments that enhance lives while
              shaping the future of real estate.
            </p>
          </div>

          {/* Right: Image */}
          <div className="order-2 lg:order-2">
            <div className="overflow-hidden rounded-xl">
              <img
                src={ourMission}
                alt="Mission Visual"
                className="w-full h-56 sm:h-64 md:h-72 lg:h-80 object-cover"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default OurMission;